import { SequenceStep } from "./Guide";
import StoryLine from "./storylines/StoryLine";

export class ToDoItem {
  id: string = "??";
  _text: string = "";
  dontSlideAway?: boolean;

  set text(newValue: string) {
    this._text = newValue;
  }
  get text(): string {
    return this._text;
  }

  interactiveSelection?: () => Array<{ text: string; execute: () => void }>;

  subSteps: Array<() => ToDoItem> | undefined;
  nextStep?: () => ToDoItem;
  prefixStep?: () => ToDoItem;
  hasToBeDoneBevoreStep?: Array<() => ToDoItem>;
  lastStep?: () => ToDoItem;
  description?: string;
  gif?: string;
  typeForPattern: string = "";
  pattern?: (type: string, lastToDoItem?: ToDoItem) => Array<SequenceStep>;
  done: (lastToDoElement?: ToDoItem) => boolean = () => {
    return false;
  };
  get executed(): boolean {
    return state.onBoardingSeenKeys.includes(this.id);
  }
  set executed(newValue: boolean) {
    if (this.id != "introStep") {
      if (newValue) {
        const x = state.onBoardingSeenKeys;
        x.push(this.id);
        state.onBoardingSeenKeys = x;
      } else {
        const x = state.onBoardingSeenKeys;
        const i = x.indexOf(this.id);
        if (i >= 0) {
          x.splice(i);
          state.onBoardingSeenKeys = x;
        }
      }
    }
  }
  prio: number = -1;
  static allToDoElements = new Array<ToDoItem>();
  static firstInHierarchie = new Array<ToDoItem>();

  constructor(data: {
    id: string;
    text: string;
    dontSlideAway?: boolean;
    nextStep?: () => ToDoItem;
    lastStep?: () => ToDoItem;
    prefixStep?: () => ToDoItem;
    subSteps: Array<() => ToDoItem> | undefined;
    done: (lastToDoElement?: ToDoItem) => boolean;
    prio: number;
    description?: string;
    gif?: string;
    typeForPattern?: string;
    pattern?: (type: string, lastToDoItem?: ToDoItem) => Array<SequenceStep>;
    fistInHirarchie?: boolean;
    hasToBeDoneBevoreStep?: Array<() => ToDoItem>;
    interactiveSelection?: () => Array<{ text: string; execute: () => void }>;
  }) {
    this.id = data.id;
    this.text = data.text;
    this.dontSlideAway = data.dontSlideAway;
    this.lastStep = data.lastStep;
    this.nextStep = data.nextStep;
    this.subSteps = data.subSteps;
    this.description = data.description;
    this.gif = data.gif;
    this.pattern = data.pattern;
    this.prefixStep = data.prefixStep;
    this.done = () => {
      return data.done() || this.alreadyDone();
    };
    this.prio = data.prio;
    this.typeForPattern = data.typeForPattern || "";
    /// because of not static variables
    //ToDoElement.allToDoElements.push(this);
    let allreadyIn = false;
    this.hasToBeDoneBevoreStep = data.hasToBeDoneBevoreStep;
    this.interactiveSelection = data.interactiveSelection;
    ToDoItem.allToDoElements.forEach((elm) => {
      if (elm.text == data.text) {
        allreadyIn = true;
      }
    });
    if (!allreadyIn) {
      ToDoItem.allToDoElements.push(this);
    }
    if (data.fistInHirarchie) {
      //check first of allready in var
      let allreadyIn = false;
      ToDoItem.firstInHierarchie.forEach((elm) => {
        if (elm.text == data.text) {
          allreadyIn = true;
        }
      });
      if (!allreadyIn) {
        ToDoItem.firstInHierarchie.push(this);
      }
    }
  }
  getPattern(lastToDoItem?: ToDoItem): Array<SequenceStep> {
    if (this.pattern) {
      if (lastToDoItem == undefined && this.lastStep) {
        return this.pattern(this.typeForPattern, this.lastStep());
      } else {
        return this.pattern(this.typeForPattern, lastToDoItem);
      }
    } else {
      return [];
    }
  }
  alreadyDone(): boolean {
    let res = false;
    state.onBoardingSeenKeys.forEach((key) => {
      if (key == this.id) {
        res = true;
      }
    });
    return res;
  }
}
